// extracted by mini-css-extract-plugin
export default {"context-menu-item":"GRnCd","context-menu-item_active":"IvYPe","context-menu-item__text":"GfAp2","context-menu-item_proportional":"yUCTz"};